import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment.prod';
import { DocumentDto, ProtocolRequest } from '@models/protocols/document.dto';
import { ProtocolDto } from '@models/protocols/protocol.dto';

@Injectable({
  providedIn: 'root',
})
export class ProtocolService {
  constructor(private http: HttpClient) {}

  getProtocols() {
    return this.http.get<ProtocolDto[]>(environment.host + '/protocols/list');
  }

  uploadProtocol(document: DocumentDto, file: ArrayBuffer) {
    let formData = new FormData();
    formData.append('file', new Blob([file]));
    for (let data of Object.keys(document)) {
      formData.append(data, document[data]);
    }
    return this.http.post(environment.host + '/protocols/upload', formData);
  }

  createProtocol(arr: ProtocolRequest[]) {
    return this.http.post<ProtocolDto>(
      environment.host + '/protocols/generate',
      arr,
    );
  }

  modifyProtocol(arr: ProtocolDto[]) {
    return this.http.post<ProtocolDto[]>(
      environment.host + '/protocols/modify',
      arr,
    );
  }

  removeProtocol(arr: ProtocolDto[]) {
    return this.http.post<ProtocolDto[]>(
      environment.host + '/protocols/remove',
      arr,
    );
  }
}
